import { orderBy, toNumber } from "lodash";
import { useMemo } from "react";
import {
  useScorecardQuery,
  Scorecard as ScorecardType,
  ScorecardRow,
} from "@/features/scorecards/graphql/generated";

interface Scorecard extends ScorecardType {
  competencies?: ScorecardRow[];
  requirements?: ScorecardRow[];
  rows?: ScorecardRow[];
}

export const useScorecard = (scorecardId?: number) => {
  const { data, loading } = useScorecardQuery({
    variables: { scorecardId: toNumber(scorecardId) },
    skip: !scorecardId,
  });

  const scorecard = useMemo(() => {
    const baseCard = data?.scorecard || ({} as Scorecard);

    const competencieGroups = [
      "Must have",
      "Important to have",
      "Good to have",
    ];

    const orderedRows = orderBy(baseCard.rows, ["id"], ["asc"]);
    return {
      ...baseCard,
      rows: orderedRows,
      competencies: orderedRows?.filter((row) =>
        competencieGroups.includes(row?.group_title || "")
      ),
      requirements: orderedRows?.filter(
        (row) => !competencieGroups.includes(row?.group_title || "")
      ),
    } as Scorecard;
  }, [data]);

  return {
    scorecard,
    loading,
  };
};
